'use strict';

define('vb/private/events/transformPayloadEventBehavior',[
  'vb/private/events/transformEventBehavior',
], (TransformEventBehavior) => {
  /**
   * @typedef {import('vb/private/stateManagement/container').default} Container
   * @typedef {import('vb/private/stateManagement/page').default} Page
   * @typedef {import('vb/private/events/eventModel').default} EventModel
   */

  /**
   * TransformPayloadEventBehavior, behavior = "transformPayload"
   *
   * @extends TransformEventBehavior
   */
  class TransformPayloadEventBehavior extends TransformEventBehavior {
    /**
     * Generates a list of function wrappers for event listeners.
     * For the transform behavior, the order is serial where the base goes first before any possible extensions.
     *
     * @param {Container|Page} container - The container instance that holds event listeners.
     * @param {EventModel} eventModel - The model defining the shape and type of the event.
     * @param {Object} eventWrapper - The wrapper containing event details.
     * @param {String} eventWrapper.name - The name of the event.
     * @param {Container} eventWrapper.origin - The container that fired the event.
     * @param {*} eventWrapper.payload - The payload of the event.
     * @param {*} eventWrapper.coercedPayload - The payload coerced to the defined payload type.
     * @param {EventModel} eventWrapper.eventModel - The EventModel defining the event.
     *
     * @returns {Array<{ container: Container|Page, fnc: function }>} An array of objects each containing a container
     * instance and its corresponding event listener function.
     *
     * @overrides
     */
    curryListeners(container, eventModel, eventWrapper) {
      const functionWrappers = [];
      const fnc = container.invokeEvent.bind(container, eventWrapper.name, eventWrapper.coercedPayload);
      functionWrappers.push({
        container,
        fnc,
      });

      if (eventModel.isInterface) {
        let fncWrappers = [];
        if (container.extensionsArray) {
          container.extensionsArray.forEach((extension) => {
            fncWrappers = this.curryListeners(extension, eventModel, eventWrapper);
            Array.prototype.push.apply(functionWrappers, fncWrappers);
          });
        }
      }

      return functionWrappers;
    }
  }

  return TransformPayloadEventBehavior;
});

